import React from "react";

const FormSectionHeader = ({ title, subtitle }) => (
  <div className="ems-fm-section-head">
    <div className="ems-fm-section-title">{title}</div>
    {subtitle && <div className="ems-fm-section-sub">{subtitle}</div>}
  </div>
);

export default FormSectionHeader;
